<template>
  <div>
    <b-message
      class="integration-request-form__message"
      type="is-info"
      icon="info-circle"
      icon-size="is-small"
      has-icon>
      {{ $t('pageIntegration.requestForm.message') }}

      <a
        @click="showForm = true"
        class="is-primary is-text has-text-weight-bold">
        {{ $t('pageIntegration.requestForm.linkText') }}
      </a>
    </b-message>

    <b-modal
      v-model="showForm"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal>
      <template>
        <ig-modal @close="showForm = false">
          <h2 class="subtitle">{{ $t('pageIntegration.requestForm.modal.title') }}</h2>

          <p class="is-size-7 content">
            {{ $t('pageIntegration.requestForm.modal.description') }}
          </p>

          <ig-form-schema
            :schema="formSchema"
            @submit="save"
          >
            <template slot="actions">
              <b-button
                native-type="submit"
                class="is-uppercase ig-external-form__submit"
                :label="$t('pageIntegration.requestForm.modal.submitBtn')"
                :loading="loadingSave"
                :disabled="loadingSave"
                type="is-primary"
                expanded></b-button>
            </template>
          </ig-form-schema>
        </ig-modal>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { EventBus, Http, IgModal } from '@integrai/ui';

export default {
  name: 'integration-request-form',
  data() {
    return {
      showForm: false,
      loadingSave: false,
      formSchema: {
        fields: [
          {
            name: 'name',
            component: 'input',
            fieldAttrs: {
              label: 'Nome do conector',
              info: 'Informe o nome da plataforma que você deseja integrar',
            },
            attrs: {
              placeholder: 'ERP XPTO',
            },
            validation: {
              name: 'Nome do conector',
              rules: 'required',
            },
          },
          {
            name: 'siteUrl',
            component: 'input',
            fieldAttrs: {
              label: 'Site do conector',
              info: 'Informe o site da plataforma que você deseja integrar',
            },
            attrs: {
              placeholder: 'https://erpxpto.com.br',
            },
            validation: {
              name: 'Site do conector',
              rules: 'required',
            },
          },
          {
            name: 'obs',
            component: 'input',
            fieldAttrs: {
              label: 'Qual sua necessidade de integração',
              info: 'Em poucas palavras nos fale o que gostaria de integrar e com qual plataforma.',
            },
            attrs: {
              placeholder: 'Gostaria de integrar os produtos e pedidos do meu ERP XPTO com minha plataforma de e-commerce Nuvemshop',
              type: 'textarea',
            },
            validation: {
              name: 'Qual sua necessidade de integração',
              rules: 'required',
            },
          },
        ],
      },
    };
  },
  methods: {
    async save(form) {
      console.log('form', form);
      this.loadingSave = true;

      try {
        await Http.post('integration-request', form);
        this.loadingSave = false;

        EventBus.$emit('toast', {
          type: 'is-success',
          message: this.$t('pageIntegration.requestForm.modal.successMessage'),
        });

        this.showForm = false;
      } catch (e) {
        this.loadingSave = false;
      }
    },
  },
  components: {
    IgModal,
  },
};
</script>

<style lang="scss">
.integration-request-form {
  &__message{
    margin-top: 2rem;
  }
}
</style>
